var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { get, TextBody, Link, ScreenReaderOnly, Icon } from '@ally/metronome-ui';
import { muiWarningFill } from '@ally/metronome-icons';
import { formatCurrency } from '@ally/aos-utils';
import { formattedDate, maskAccount, spreadNumberA11y } from '../utils';
import { StyledTextBody, UL, LI, StyledDL, StyledDT, StyledDD, } from './SharedStyles';
var IconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin-right: ", ";\n  margin-top: ", ";\n"], ["\n  display: flex;\n  margin-right: ", ";\n  margin-top: ", ";\n"])), get.space('xs'), get.space('xxs'));
var NeedsAttentionContainer = styled(TextBody)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  align-items: flex-start;\n"])));
export var WireRequestedDescription = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(UL, null,
            React.createElement(LI, null, "Thanks for submitting. We received your wire request."),
            React.createElement(LI, null, "Next, we'll let you know when we begin reviewing your request. We'll let you know when we start processing your wire, and again when we've sent it.")),
        React.createElement(StyledTextBody, { tag: "p", size: "sm", mb: "sm" },
            "If we need to contact you for additional verification, we'll call you from",
            ' ',
            React.createElement(Link, { to: "tel:1-877-247-2559", text: "1-877-247-2559", withAllyTM: "1-877-247-2559", "aria-label": "1, 8 7 7, 2 4 7, 2 5 5 9" }),
            ' ',
            "at the number in your online banking",
            ' ',
            React.createElement(Link, { text: "profile", to: "/profile" }),
            "."),
        React.createElement(TextBody, { tag: "p", size: "sm" },
            "To cancel this wire transfer request, call us immediately at",
            ' ',
            React.createElement(Link, { to: "tel:1-877-247-2559", text: "1-877-247-2559", withAllyTM: "1-877-247-2559", "aria-label": "1, 8 7 7, 2 4 7, 2 5 5 9" }),
            ".")));
};
export var WireReviewingDescription = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(UL, null,
            React.createElement(LI, null,
                "We're reviewing your wire request to make sure we don't need any further information from you. If we do, we'll call you at the number in your ",
                React.createElement(Link, { text: "profile", to: "/profile" }),
                "."),
            React.createElement(LI, null,
                "We process wires until 3pm",
                ' ',
                React.createElement(TextBody, { tag: "span", size: "sm", "aria-label": "Eastern Time" }, "ET"),
                ' ',
                "on business days, so there may be a delay if you submitted your request after 3pm",
                ' ',
                React.createElement(TextBody, { tag: "span", size: "sm", "aria-label": "Eastern Time" }, "ET"),
                ' ',
                "or on a weekend or holiday.")),
        React.createElement(StyledTextBody, { tag: "p", size: "sm", mb: "sm" },
            "To cancel this wire transfer request, call us immediately at",
            ' ',
            React.createElement(Link, { to: "tel:1-877-247-2559", text: "1-877-247-2559", withAllyTM: "1-877-247-2559", "aria-label": "1, 8 7 7, 2 4 7, 2 5 5 9" }),
            ".")));
};
export var WireNeedsAttentionDescription = function () {
    return (React.createElement(NeedsAttentionContainer, { tag: "div", size: "sm" },
        React.createElement(IconWrapper, { "aria-label": "Needs Attention", role: "img" },
            React.createElement(Icon, { icon: muiWarningFill, fill: "warning", size: "md", "aria-hidden": true })),
        React.createElement(TextBody, { tag: "p", size: "sm" },
            "Action Required: We need more information from you. Call us at",
            ' ',
            React.createElement(Link, { to: "tel:1-877-247-2559", text: "1-877-247-2559", withAllyTM: "1-877-247-2559", "aria-label": "1, 8 7 7, 2 4 7, 2 5 5 9" }),
            ' ',
            "so we can continue processing this wire.")));
};
export var WireProcessingDescription = function (_a) {
    var statuses = _a.statuses;
    var processing = statuses[0].status === 'Processing';
    var attentionResolved = statuses.findIndex(function (history) { return history.status === 'VerificationRequired'; }) ===
        1;
    if (processing && attentionResolved) {
        return (React.createElement(UL, null,
            React.createElement(LI, null, "Now that we have what we need, we're moving forward with your wire request."),
            React.createElement(LI, null,
                "The next step is to send your funds, which should happen today by 6 pm",
                React.createElement(TextBody, { tag: "span", size: "sm", "aria-label": "Eastern Time" }, "ET"),
                ".")));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(UL, null,
            React.createElement(LI, null, "We're processing your wire request."),
            React.createElement(LI, null,
                "The next step is to send your funds, which should happen today by 6 pm",
                ' ',
                React.createElement(TextBody, { tag: "span", size: "sm", "aria-label": "Eastern Time" }, "ET"),
                ".")),
        React.createElement(StyledTextBody, { tag: "p", size: "sm", mb: "sm" },
            "If we need to contact you for additional verification, we'll call the number in your ",
            React.createElement(Link, { text: "profile", to: "/profile" }),
            ".")));
};
export var WireCanceledDescription = function (_a) {
    var statuses = _a.statuses;
    return (React.createElement(TextBody, { tag: "p", size: "sm" },
        "We canceled your wire transfer on",
        ' ',
        React.createElement(TextBody, { tag: "span", size: "sm" }, formattedDate(statuses[0].eventDateTime, 'MMM D')),
        "."));
};
export var WireSentDescription = function () {
    return (React.createElement(TextBody, { tag: "p", size: "sm" }, "We sent your wire transfer."));
};
export var StatusModalWireDetails = function (_a) {
    var event = _a.event;
    var _b = event.eventModelData, fromAccountName = _b.fromAccountName, fromAccountNumber = _b.fromAccountNumber, wireAmount = _b.wireAmount, wireFee = _b.wireFee, bankName = _b.bankName, recipientRoutingNumber = _b.recipientRoutingNumber, recipientAccountNumber = _b.recipientAccountNumber, recipientName = _b.recipientName, additionalInstructions = _b.additionalInstructions, statuses = event.statuses;
    var requestedDate = statuses && statuses.find(function (history) { return history.status === 'Requested'; });
    var unformattedTotal = (wireFee || 0) + wireAmount;
    return (React.createElement(StyledDL, { tag: "dl", size: "sm" },
        React.createElement(StyledDT, { tag: "dt", size: "sm", weight: "bold" }, "From:"),
        React.createElement(StyledDD, { tag: "dd", size: "sm", "data-private": true }, maskAccount(fromAccountName, fromAccountNumber)),
        React.createElement(StyledDT, { tag: "dt", size: "sm", weight: "bold" }, "Wire Amount:"),
        React.createElement(StyledDD, { tag: "dd", size: "sm" }, formatCurrency.asCurrency(wireAmount)),
        wireFee ? (React.createElement(React.Fragment, null,
            React.createElement(StyledDT, { tag: "dt", size: "sm", weight: "bold" }, "Wire Fee:"),
            React.createElement(StyledDD, { tag: "dd", size: "sm" }, formatCurrency.asCurrency(wireFee)),
            React.createElement(StyledDT, { tag: "dt", size: "sm", weight: "bold" }, "Total:"),
            React.createElement(StyledDD, { tag: "dd", size: "sm" }, formatCurrency.asCurrency(unformattedTotal)))) : null,
        requestedDate && (React.createElement(React.Fragment, null,
            React.createElement(StyledDT, { tag: "dt", size: "sm", weight: "bold" }, "Request Date:"),
            React.createElement(StyledDD, { tag: "dd", size: "sm" }, formattedDate(requestedDate.eventDateTime, 'MMM D, YYYY')))),
        React.createElement(StyledDT, { tag: "dt", size: "sm", weight: "bold" }, "Bank Name:"),
        React.createElement(StyledDD, { tag: "dd", size: "sm", "data-private": true }, bankName),
        React.createElement(StyledDT, { tag: "dt", size: "sm", weight: "bold" }, "Recipient Routing Number:"),
        React.createElement(StyledDD, { tag: "dd", size: "sm", "data-private": true },
            React.createElement(TextBody, { tag: "span", size: "sm", "aria-hidden": "true" }, recipientRoutingNumber),
            React.createElement(ScreenReaderOnly, null, spreadNumberA11y(recipientRoutingNumber))),
        React.createElement(StyledDT, { tag: "dt", size: "sm", weight: "bold" }, "Recipient Account Number:"),
        React.createElement(StyledDD, { tag: "dd", size: "sm", "data-private": true },
            React.createElement(TextBody, { tag: "span", size: "sm", "aria-hidden": "true" }, recipientAccountNumber),
            React.createElement(ScreenReaderOnly, null, spreadNumberA11y(recipientAccountNumber))),
        React.createElement(StyledDT, { tag: "dt", size: "sm", weight: "bold" }, "Recipient:"),
        React.createElement(StyledDD, { tag: "dd", size: "sm", "data-private": true }, recipientName),
        additionalInstructions && (React.createElement(React.Fragment, null,
            React.createElement(StyledDT, { tag: "dt", size: "sm", weight: "bold" },
                "Additional Instructions/",
                React.createElement("br", null),
                "For Further Credit To:"),
            React.createElement(StyledDD, { tag: "dd", size: "sm" }, additionalInstructions)))));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=StatusModalWireData.js.map